import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const ADD_INVENTORY = SERVER_URI + '/inventory';
const GET_INVENTORY = SERVER_URI + '/get-inventory';
const UPDATE_INVENTORY = SERVER_URI + '/inventory/';
const UPDATE_STATUS = SERVER_URI + '/toggle-inventory-status/';

const UPDATE_INGREDIENT_STATUS = SERVER_URI + '/inventory-change-status/';
const GET_SALE_PRODUCT_INVENTORY = SERVER_URI + '/get-sale-product-inventory/';
const ADD_MAP_INVENTORY_LOCATION = SERVER_URI + '/map-inventory-location';
const GET_INVENTORY_LOCATION = SERVER_URI + '/get-inventory-location';
const UPDATE_INVENTORY_LOCATION_MAPPING = SERVER_URI + '/update-inventory-location-mapping/';
const ADD_STOCK = SERVER_URI + '/add-stock/';

export default {
    Create_inventory: async function (paylaod) {
        return apiPost(ADD_INVENTORY, paylaod)
    },
    Get_inventory_List: async function (paylaod) {
        return apiPost(GET_INVENTORY, paylaod)
    },
    Update_inventory: async function (id, payload) {
        return apiPut(UPDATE_INVENTORY + id, payload)
    },
    Update_Status: async function (payload) {
        return apiPost(UPDATE_STATUS,payload)
    },
    bind_Sale_Product_inventory: async function (id) {
        return apiGet(GET_SALE_PRODUCT_INVENTORY + id)
    },
    addInventoryLocation: async function (payload) {
        return apiPost(ADD_MAP_INVENTORY_LOCATION, payload);
    },
    getInventoryLocationData: async function (payload) {
        return apiPost(GET_INVENTORY_LOCATION, payload);
    },
    updateInventoryLocationMapping: async function (payload) {
        return apiPost(UPDATE_INVENTORY_LOCATION_MAPPING, payload);
    },
    addStock: async function (id, payload) {
        return apiPost(ADD_STOCK + id, payload);
    },
    updateIngredientStatus: async function (id) {
    return apiGet(UPDATE_INGREDIENT_STATUS + id);
},
};